import { BaseTool } from "../BaseTool.js";
import { RectangleObject } from "../../data/models/RectangleObject.js";
import { createDotData, createStyledDot, getToolOptions, isPrimaryPointer } from "../toolHelpers.js";

export class RectangleTool extends BaseTool {
  constructor() {
    super("rectangle");
    this.draftStart = null;
  }

  onPointerDown(context) {
    if (!isPrimaryPointer(context)) {
      return;
    }

    this.draftStart = { ...context.worldPoint };
    context.clearPreview();
  }

  onPointerMove(context) {
    if (!this.draftStart) {
      return;
    }

    const preview = this.createPreview(context, this.draftStart, context.worldPoint);

    if (preview) {
      context.setPreview(preview);
      return;
    }

    context.clearPreview();
  }

  onPointerUp(context) {
    if (!this.draftStart || !isPrimaryPointer(context)) {
      return;
    }

    const corners = getRectangleCorners(this.draftStart, context.worldPoint);
    const toolOptions = getToolOptions(context.config);
    this.cancel();
    context.clearPreview();

    if (corners.length === 0) {
      return;
    }

    const dots = corners.map((point) => createStyledDot(context, point, "rectangle-point"));

    context.dataManager.addObject(
      new RectangleObject({
        id: context.dataManager.createUniqueObjectId("rectangle"),
        points: dots.map((dot) => dot.id),
        strokeColor: toolOptions.strokeColor,
        fillColor: toolOptions.rectangleFilled ? toolOptions.fillColor : "transparent",
        lineWidth: toolOptions.lineWidth
      })
    );

    context.render();
  }

  cancel() {
    this.draftStart = null;
  }

  createPreview(context, startPoint, endPoint) {
    const corners = getRectangleCorners(startPoint, endPoint);

    if (corners.length === 0) {
      return null;
    }

    const toolOptions = getToolOptions(context.config);
    const dots = corners.map((point, index) => createDotData(context, point, `preview-rectangle-point-${index + 1}`));

    return {
      type: "rectangle",
      dots,
      objects: [{
        id: "preview-rectangle",
        type: "rectangle",
        points: dots.map((dot) => dot.id),
        strokeColor: toolOptions.strokeColor,
        fillColor: toolOptions.rectangleFilled ? toolOptions.fillColor : "transparent",
        lineWidth: toolOptions.lineWidth
      }],
      opacity: 0.56
    };
  }
}

function getRectangleCorners(start, end) {
  const left = Math.min(start.x, end.x);
  const right = Math.max(start.x, end.x);
  const top = Math.min(start.y, end.y);
  const bottom = Math.max(start.y, end.y);

  if (left === right || top === bottom) {
    return [];
  }

  return [
    { x: left, y: top },
    { x: right, y: top },
    { x: right, y: bottom },
    { x: left, y: bottom }
  ];
}
